import { validateParams } from '../_utils/insertSQL';
import { spliceUpdateSQLByConditions } from '../_utils/updateSQL';
export default function (_a) {
    var env = _a.env, data = _a.data, outputs = _a.outputs, inputs = _a.inputs, onError = _a.onError;
    inputs['params'](function (val) {
        var _a;
        var isEdit = (_a = env.runtime) === null || _a === void 0 ? void 0 : _a.debug;
        if (data.rules) {
            try {
                validateParams(val, data.rules.entities[0], data.rules.conAry, false);
                env.collect('更新数据 params: ', val);
                var sql = spliceUpdateSQLByConditions({
                    conditions: data.rules.conditions,
                    connectors: data.rules.conAry,
                    entities: data.rules.entities,
                    params: val,
                    isEdit: isEdit,
                    encrypt: env.encrypt,
                });
                env.collect('更新数据 sql: ', sql);
                env.executeSql(sql)
                    .then(function () { return outputs['rtn'](); })
                    .catch(function (ex) { return onError("\u6267\u884CSQL\u53D1\u751F\u9519\u8BEF,".concat(ex === null || ex === void 0 ? void 0 : ex.message)); });
            }
            catch (error) {
                isEdit ? console.error('执行SQL发生错误, ', error) : undefined;
                onError("\u6267\u884C\u9519\u8BEF, ".concat(error === null || error === void 0 ? void 0 : error.message));
            }
        }
    });
}
